<template>
  <section id="service">
    <v-container fluid id="services" class="mt-2">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="space-around" class="flex-wrap">
            <v-col
              cols="12"
              sm="12"
              md="4"
              class="text-center"
              v-for="(feature, i) in features"
              :key="i"
            >
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="card"
                  shaped
                  :elevation="hover ? 10 : 4"
                  :class="{ up: hover }"
                  @click="openServiceDialog(feature)"
                >
                  <Logo :icon="feature.icon" :type="feature.type" />
                  <h1 class="font-weight-regular">{{ feature.title }}</h1>
                  <h4 class="font-weight-regular subtitle-1">
                    {{ feature.text }}
                  </h4>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-dialog v-model="showServiceDialog" max-width="750px">
        <v-card>
          <v-card-title class="headline text-center justify-center">
            <Logo :icon="selectedFeature.icon" :type="selectedFeature.type" class="mr-2"/>
            {{ selectedFeature.title }}
          </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item
                v-for="(element, index) in selectedFeature.elements"
                :key="index"
              >
                <v-list-item-content>
                  <v-list-item-title
                    class="justify-center text-h6 "
                  >
                    <v-icon color="secondary" class="mr-2">mdi-check-circle</v-icon>
                    {{ element }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="showServiceDialog = false">Bezárás</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container fluid class="secondary white--text py-16">
      <v-row justify="center">
        <v-col cols="12" lg="10">
          <v-row align="center">

            <v-col cols="12" md="5" class="text-center">
              <v-img
                src="@/assets/img/autofolia.jpg"
                max-width="500"
                class="mx-auto rounded-lg elevation-8"
              />
            </v-col>

            <v-col cols="12" md="7">

              <h1 class="font-weight-bold mb-4">
                Már autófóliázással is várjuk ügyfeleinket
              </h1>

              <h3 class="font-weight-regular mb-6">
                Professzionális autófóliázási szolgáltatásainkkal nemcsak
                járműve megjelenését tesszük még elegánsabbá, hanem annak
                védelméről és kényelméről is gondoskodunk.
              </h3>

              <div class="text-body-1 mb-6">

                <p>
                  ✓ <strong>Ablakfóliázás</strong> a kellemesebb utastérért,
                  kisebb hőterhelésért és UV-védelemért.
                </p>

                <p>
                  ✓ <strong>Karosszéria fóliázás</strong> egyedi megjelenéshez
                  és a fényezés hosszú távú védelméhez.
                </p>

                <p>
                  ✓ Prémium minőségű fóliák, precíz kivitelezés és tartós
                  eredmény.
                </p>
                <p>
                  ✓ Minden elvégzett fóliázáshoz hivatalos dokumentációt biztosítunk, amely igazolja a szabályos.
                </p>

              </div>

              <v-divider class="mb-5" dark></v-divider>

              <h2 class="mb-3">
                Érdeklődés és időpontfoglalás:
              </h2>
              <p class="text-h6 mb-2">
                <Logo icon="mdi-calendar"/>Hétköznap 10:00 – 14:00 között
              </p>
              <p class="text-h6 mb-2">
                <a
                  href="tel:+36205843045"
                  class="white--text text-decoration-none"
                >
                  <Logo icon="mdi-phone"/>+36 20 584 3045
                </a>
              </p>

              <p class="text-h6 mb-6">
                <a
                  href="mailto:andifolia5@gmail.com"
                  class="white--text text-decoration-none"
                >
                  <Logo icon="mdi-email"/>andifolia5@gmail.com
                </a>
              </p>
            </v-col>

          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="7">
              <h1 class="font-weight-light responsive-display mt-8 mb-4">Rólam és a szolgáltatásaimról részletesen:</h1>
              <v-row>
                <v-col cols="12" class="d-flex align-center">
                  <p class="text-justify">
                    A szakmában 2013 óta dolgozom Autóvillamosági-Műszerész és
                    Technikusként, de ez nem azt jelenti, hogy csak villamossági javításokat vállalok.
                    Precíz és gondos szerelőként igyekszem minden téren megfelelni
                    meglévő partnereimnek és új ügyfeleimnek is. 2019-től bővítettem a
                    szakmai tudásomat és tapasztalataimat Építőipari és Munkagépek
                    teljeskörű javítását és szervizelését illetően.
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <p class="text-justify">
                    Szervizem széles körű szolgáltatásokat kínál, melyek között megtalálhatók az olajcserék, fékrendszer karbantartás, futómű felújítás, 
                    motoralkatrészek tisztítása, és a motor teljes generálja. Emellett vállalom a turbófelújítást, befecskendező egységek vizsgálatát, 
                    valamint DPF/DOC szűrők tisztítását is. Teljes körű diagnosztikai szolgáltatásaim segítségével gyorsan és hatékonyan azonosítom és javítom a hibákat, 
                    legyen szó bármilyen elektronikai vagy mechanikai problémáról.
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <p class="text-justify">
                    Különös figyelmet fordítok az építőipari gépek karbantartására és javítására. Tudom, hogy ezek a gépek elengedhetetlenek a zökkenőmentes munkavégzéshez, 
                    ezért a javításokat és karbantartásokat helyszíni kiszállással, az előre egyeztetett helyszínen végzem. Legyen szó hidraulikus rendszerek javításáról, 
                    munkahengerek és vezértömbök karbantartásáról, vagy gémek hézagolásáról és perselyezéséről, megbízható és hatékony megoldásokat kínálok.
                  </p>
                </v-col>
                <v-col cols="12" class="d-flex align-center">
                  <p class="text-justify">
                    Szolgáltatásaink listája kibővült autófóliázással, mely egyszerre nyújt esztétikai, komfort és biztonságos megoldást az ügyfeleink számára.
                    Okleveles fóliázóként prémium alapanyagok használata mellett precíz és tartós felhelyezést biztosítok. 
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="5" class="d-sm-flex d-md-flex mt-10">
              <v-img
                src="@/assets/img/car-repair2.svg"
                class="d-block ml-auto mr-auto"
                max-width="400px"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import Logo from './Logo.vue';

  export default {
    components: {
      Logo
    },
    data() {
      return {
        features: [
          {
            title: "Olajok és szűrők cseréje",
            text: "Motorolaj, automata- és manuális váltóolaj, szervo olaj, fékolaj, hidraulika olaj, differenciálmű olaj, \
            valamint a szűrők cseréje révén biztosítom járműve zavartalan működését.",
            type: "mdi",
            icon: "mdi-oil",
            elements: [
              "Motorolaj",
              "Automata és manuális váltóolaj",
              "Differenciálmű olaj",
              "Szervo olaj",
              "Fékolaj",
              "Hidraulika olaj",
              "Olajszűrő",
              "Üzemanyagszűrő",
              "Pollenszűrő"
            ]
          },
          {
            title: "Futómű és fékrendszer karbantartás",
            text: "Teljeskörű fékszervizt és futómű javítást végzek. \
            Ellenőrzöm és szükség esetén cserélem a fékbetéteket, féktárcsákat és a fékfolyadékot. \
            Emellett lengéscsillapítók, stabilizátor rudak, kormánymű alkatrészek, rugók és lengőkarok cseréjét végzem.",
            type: "svg",
            icon: require('@/assets/img/brake-icon.svg'),
            elements: [
              "Teljeskörű fékszerviz",
              "Lengéscsillapítók cseréje",
              "Stabilizátor rudak cseréje",
              "Kormánymű alkatrészek javítása vagy cseréje",
              "Rugók cseréje",
              "Lengőkarok és alkatrészeinek kicserélése"
            ]
          },
          {
            title: "Motor karbantartása",
            text: "Szolgáltatásom közé tartozik a dióhéjas szívósortisztítás, hengerfej felújítás, \
            turbó felújítás vagy cseréje, befecskendező egységek vizsgálata, javítása, valamint a DPF/DOC szűrők tisztítása vagy cseréje.",
            type: "mdi",
            icon: "mdi-engine",
            elements: [
              "Dióhéjas szívósortisztítás",
              "Motor alkatrészeinek tisztítása",
              "Teljes motorgenerál",
              "Hengerfej felújítás",
              "Turbó felújítása vagy cseréje",
              "Befecskendező egységek vizsgálata, javítása vagy cseréje",
              "DPF/DOC szűrők tisztítása vagy cseréje"
            ]
          },
          {
            title: "Vezérlések cseréje",
            text: " A szíjas vagy láncos vezérlések cseréje biztosítja a motor megfelelő időzítését, \
            ami elengedhetetlen a motor hosszú távú megbízható működéséhez.",
            type: "mdi",
            icon: "mdi-wrench",
            elements: [
              "Szíjas vezérlés cseréje",
              "Láncos vezérlés cseréje"
            ]
          },
          {
            title: "Diagnosztika, Vezetékek-, jeladók-, multimédiás eszközök javítása és cseréje:",
            text: "A hibás vezetékek és jeladók javításával vagy cseréjét biztosítom. Rádió vagy multimédiás fejegység, hangszórók szakszerű javítását és beszerelését végzem",
            type: "mdi",
            icon: "mdi-car-connected",
            elements: [
              "Teljeskörű OBD II diagnosztika",
              "Jeladók cseréje",
              "Vezetékek javítása vagy cseréje",
              "Egyéb diagnosztikai vizsgálatok"
            ]
          },
          {
            title: "Motorvezérlők programozása",
            text: "A motorvezérlők programozásával optimalizálom a motor működését, növelve ezzel a teljesítményt és a hatékonyságot.",
            type: "mdi",
            icon: "mdi-laptop",
            elements: [
              "Motorvezérlők diagnosztikája",
              "Motorvezérlők felprogramozása"
            ]
          },
          {
            title: "AdBlue befecskendező rendszer javítása",
            text: "Az AdBlue befecskendező rendszer vizsgálata és javítása révén biztosítom a \
            megfelelő NOx-kibocsátást, így járműve megfelel a legszigorúbb környezetvédelmi előírásoknak is.",
            type: "svg",
            icon: require('@/assets/img/fuel-can-icon.svg'),
            elements: [
              "AdBlue befecskendező rendszer vizsgálata",
              "AdBlue befecskendező rendszer javítása"
            ]
          },
          {
            title: "Hidraulika rendszerek kiépítése és javítása",
            text: "Hidraulika rendszerek kiépítése és javítása során biztosítom, hogy építőipari gépei mindig \
            a legnagyobb teljesítményt nyújtsák, és hosszú távon is megbízhatóak maradjanak.",
            type: "mdi",
            icon: "mdi-pipe-leak",
            elements: [
              "Hidraulika rendszerek kiépítése és javítása",
              "Hidraulikus munkahengerek és vezértömbök javítása"
            ]
          },
          {
            title: "Építőipari gépek javítása és karbantartása",
            text: "A turbó felújítása vagy cseréje során a meghibásodott vagy elhasználódott turbófeltöltőt javítom vagy cserélem, \
            hogy járműve ismét optimális teljesítményt nyújtson.",
            type: "svg",
            icon: require('@/assets/img/construction-excavator-icon.svg'),
            elements: [
              "Kanalak és gyorscsatlakozók felmérése és javítása",
              "Gémek hézagolása, perselyezése, csapolása"
            ]
          }
        ],
        showServiceDialog: false,
        selectedFeature: {}
      }
    },
    methods: {
      openServiceDialog(feature) {
        this.selectedFeature = feature;
        this.showServiceDialog = true;
      }
  }
  };
</script>

<style scoped>
#about {
  background-color: #f4f7f5;
}
.responsive-h1 {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}
.responsive-display {
  font-size: 2rem; /* Alapértelmezett betűméret */
}
.autofolia {
  background-color: #8A8C99;
}

@media (min-width: 600px) {
  .responsive-display {
    font-size: 2.5rem; /* Közepes képernyő */
  }
}

@media (min-width: 960px) {
  .responsive-display {
    font-size: 2.75rem; /* Nagy képernyő */
  }
}

@media (min-width: 1264px) {
  .responsive-display {
    font-size: 3rem; /* Extra nagy képernyő */
  }
}
</style>
